var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderPage'),_c('div',{staticClass:"content"},[_c('SlideShow')],1),_c('div',{staticStyle:{"width":"80%","margin":"auto"}},[_c('CompanyPage')],1),_c('FooterPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }